import React from "react";
import { Button, FileUpload } from "@opendate-app/setlist";

import { useMarketingSettingsContext } from "../MarketingSettingsIndexContainer";
import { toastError } from "../../../../shared/toastHelper";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    maxWidth: 480,
  },
  preview: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
  logo: {
    height: 80,
    maxWidth: "100%",
    objectFit: "contain",
  },
};

const LogoSelect = () => {
  const {
    logoThumbUrl,
    chooseLogo,
    removeLogo,
  } = useMarketingSettingsContext();

  const handleFilesSelected = (files) => {
    const file = files[0];
    if (file && !file.type.startsWith("image/")) {
      toastError("The logo must be an image file");
    } else if (file) {
      chooseLogo(file);
    }
  };

  const handleRemoveClick = () => {
    if (window.confirm("Are you sure you want to remove the logo?")) {
      removeLogo();
    }
  };

  return (
    <div style={styles.container}>
      {logoThumbUrl ? (
        <div style={styles.preview}>
          <img src={logoThumbUrl} style={styles.logo} alt="Logo" />
          <Button variant="link-destructive" onClick={handleRemoveClick}>Remove</Button>
        </div>
      ) : null}
      <FileUpload
        hint="Recommended resolution of at least 256px wide."
        onFilesSelected={handleFilesSelected}
      />
    </div>
  );
};

export default LogoSelect;
